import React from 'react';
import { SummedReport } from '../../../models/ReportData';
import ReportProgressTracker from './ReportProgressTracker';
import EmptyReport from '../EmptyReport';
import { findPricebookReportsByType } from '../../../data/report/helpers/pricebookReportUtils';
import { ProductTypeEnum } from '../../../models/PricebookData';
import { Box } from '@mui/material';

interface ReportUserProgressProps {
  summedReport: SummedReport | null;
}
const ReportUserProgress: React.FC<ReportUserProgressProps> = ({ summedReport }) => {
  if (!summedReport) return null;

  const pricebookReports = findPricebookReportsByType(summedReport);
  const uniqueProductTypes: ProductTypeEnum[] = [
    ...new Set(
      pricebookReports
        .map(pricebook => pricebook?.productType)
        .filter(
          (type): type is ProductTypeEnum => type !== undefined && type !== ProductTypeEnum.Total,
        ),
    ),
  ];

  const totalNickelsU = summedReport.totalNickelsU || 0;
  if (totalNickelsU > 0 && !uniqueProductTypes.includes(ProductTypeEnum.NickelsU)) {
    uniqueProductTypes.push(ProductTypeEnum.NickelsU);
  }

  const guidedChoiceOnly = uniqueProductTypes.every(type => type === ProductTypeEnum.GuidedChoice);

  if (uniqueProductTypes.length <= 0) {
    return <EmptyReport />;
  }

  return (
    <Box display={guidedChoiceOnly ? 'flex' : 'inline'}>
      {uniqueProductTypes.map(productType => (
        <ReportProgressTracker
          key={productType}
          summedReport={summedReport}
          productType={productType}
          guidedChoiceOnly={guidedChoiceOnly}
        />
      ))}
    </Box>
  );
};

export default ReportUserProgress;
